export default __webpack_public_path__ + "static/BZ_COBERTURADC_EP_R00-1_Pgina_12-31d5b07faaa2a1fd71a831a57b23a4f1.jpg";